/**
 * 
 * 
 *
 * 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { NeskoAbDetailEntryMeta } from '../model/models';
import { NeskoAbGrundstueckBeziehungListEntryMeta } from '../model/models';
import { NeskoAbStandardRequestMeta } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class AmtlichebewertungNeskoService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param gemeindeId 
     * @param nummer 
     * @param nummer2 
     * @param nummer3 
     * @param grundstueckId 
     * @param sprache 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadSichtByGrundstueckNummer(gemeindeId?: string, nummer?: string, nummer2?: string, nummer3?: string, grundstueckId?: string, sprache?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<NeskoAbDetailEntryMeta>;
    public loadSichtByGrundstueckNummer(gemeindeId?: string, nummer?: string, nummer2?: string, nummer3?: string, grundstueckId?: string, sprache?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<NeskoAbDetailEntryMeta>>;
    public loadSichtByGrundstueckNummer(gemeindeId?: string, nummer?: string, nummer2?: string, nummer3?: string, grundstueckId?: string, sprache?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<NeskoAbDetailEntryMeta>>;
    public loadSichtByGrundstueckNummer(gemeindeId?: string, nummer?: string, nummer2?: string, nummer3?: string, grundstueckId?: string, sprache?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (gemeindeId !== undefined && gemeindeId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gemeindeId, 'gemeindeId');
        }
        if (nummer !== undefined && nummer !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nummer, 'nummer');
        }
        if (nummer2 !== undefined && nummer2 !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nummer2, 'nummer2');
        }
        if (nummer3 !== undefined && nummer3 !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nummer3, 'nummer3');
        }
        if (grundstueckId !== undefined && grundstueckId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>grundstueckId, 'grundstueckId');
        }
        if (sprache !== undefined && sprache !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sprache, 'sprache');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<NeskoAbDetailEntryMeta>(`${this.configuration.basePath}/amtlichebewertung/neskoab/sichtGrundstueck`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param zpvNummer 
     * @param sprache 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadSichtByZpvNummer(zpvNummer: string, sprache?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<NeskoAbGrundstueckBeziehungListEntryMeta>>;
    public loadSichtByZpvNummer(zpvNummer: string, sprache?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<NeskoAbGrundstueckBeziehungListEntryMeta>>>;
    public loadSichtByZpvNummer(zpvNummer: string, sprache?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<NeskoAbGrundstueckBeziehungListEntryMeta>>>;
    public loadSichtByZpvNummer(zpvNummer: string, sprache?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (zpvNummer === null || zpvNummer === undefined) {
            throw new Error('Required parameter zpvNummer was null or undefined when calling loadSichtByZpvNummer.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (zpvNummer !== undefined && zpvNummer !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>zpvNummer, 'zpvNummer');
        }
        if (sprache !== undefined && sprache !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sprache, 'sprache');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<NeskoAbGrundstueckBeziehungListEntryMeta>>(`${this.configuration.basePath}/amtlichebewertung/neskoab/sichtPerson`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchStandardTemplate(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<NeskoAbStandardRequestMeta>;
    public searchStandardTemplate(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<NeskoAbStandardRequestMeta>>;
    public searchStandardTemplate(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<NeskoAbStandardRequestMeta>>;
    public searchStandardTemplate(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<NeskoAbStandardRequestMeta>(`${this.configuration.basePath}/amtlichebewertung/neskoab/searchStandardTemplate`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
